import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "navbar fixed z-20 w-full bg-[rgba(106,153,143,.85)] backdrop-blur-md font-merriweather" }
const _hoisted_2 = { class: "h-12 flex flex-row justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "navbar bg-[rgba(106,153,143,0.85)] p-10 left-0 top-12 w-full h-[calc(100vh-3rem)] flex flex-col fixed z-1000 backdrop-blur-md overflow-auto"
}
const _hoisted_4 = { class: "flex flex-col items-center justify-center gap-8 mt-10" }

import { watch, ref } from 'vue';
import { useRouter } from 'vue-router';
import MobileNavDropdown from '../global/MobileNavDropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavBar',
  setup(__props) {

const router = useRouter();

const isOpen = ref(false);

watch(isOpen, (open) => {
  const main = document.getElementById("main-area");
  if (open) {
    document.body.style.overflow = "hidden";
    if (main) main.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
    if (main) main.style.overflow = "";
  }
});

const toggleMenu = (): void => {
    isOpen.value = !isOpen.value;
}

const closeMenuTitle = (): void => {
  isOpen.value = false;
  router.push('/');
};

const aboutMeOptions = {
  "My Bio": "/about-me",
  "Hobbies & Interests": "/interests"
}

const projectsOptions = {
  "All Projects": "/projects",
  "POVO Class Registration": "/povo-interface",
  "clairgreen.com": "/my-website",
  "Turn-Based Battle Sim": "/rpg-battle-sim",
  "Eagle Project": "/eagle-project",
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "site-title text-xl text-[#eaf2ef] font-medium flex items-center ml-4 h-full",
          onClick: _withModifiers(closeMenuTitle, ["prevent"])
        }, "Clair Green"),
        _createElementVNode("button", {
          class: "hamburger mr-4 relative w-10 grid place-items-center",
          "aria-label": "Open Menu",
          onClick: toggleMenu
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md transition-all duration-300 ease-in-out", isOpen.value ? 'translate-y-0 rotate-45' : '-translate-y-2 rotate-0'])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md transition-all duration-200 ease-in-out", isOpen.value ? 'opacity-0' : 'opacity-100'])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md transition-all duration-300 ease-in-out", isOpen.value ? 'translate-y-0 -rotate-45' : 'translate-y-2 rotate-0'])
          }, null, 2)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "menu-slide" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "link text-2xl",
                  onClick: toggleMenu
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Home")
                  ])),
                  _: 1
                }),
                _createVNode(MobileNavDropdown, {
                  title: 'About Me',
                  options: aboutMeOptions,
                  onCloseMenu: toggleMenu
                }),
                _createVNode(MobileNavDropdown, {
                  title: 'My Projects',
                  options: projectsOptions,
                  onCloseMenu: toggleMenu
                }),
                _createVNode(_component_router_link, {
                  to: "/skills-experience",
                  class: "link text-2xl",
                  onClick: toggleMenu
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Skills & Experience")
                  ])),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "link text-2xl",
                  onClick: toggleMenu
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Contact Me")
                  ])),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})